import React, { useState, useEffect, createContext, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import PropTypes from 'prop-types'

export const KioskModeContext = createContext()

const KIOSK_MODE_STORAGE_KEY = 'televu_kiosk_mode'

export const KioskModeContextProvider = ({ children }) => {
  const [searchParams] = useSearchParams()
  const [kioskMode, setKioskModeState] = useState(() => {
    // Check URL parameter first
    const urlKiosk = searchParams.get('kiosk')
    if (urlKiosk === 'true') {
      return true
    }
    // Fall back to localStorage
    const stored = localStorage.getItem(KIOSK_MODE_STORAGE_KEY)
    return stored === 'true'
  })

  // Update localStorage when kioskMode changes
  useEffect(() => {
    localStorage.setItem(KIOSK_MODE_STORAGE_KEY, kioskMode.toString())
  }, [kioskMode])

  // Check URL parameter on mount and when it changes
  useEffect(() => {
    const urlKiosk = searchParams.get('kiosk')
    if (urlKiosk === 'true') {
      setKioskModeState(true)
    } else if (urlKiosk === 'false') {
      setKioskModeState(false)
    }
  }, [searchParams])

  const setKioskMode = useCallback((value) => {
    setKioskModeState(value)
  }, [])

  const toggleKioskMode = useCallback(() => {
    setKioskModeState((prev) => !prev)
  }, [])

  const exitKioskMode = useCallback(() => {
    setKioskModeState(false)
    localStorage.removeItem(KIOSK_MODE_STORAGE_KEY)
  }, [])

  return (
    <KioskModeContext.Provider
      value={{
        kioskMode,
        setKioskMode,
        toggleKioskMode,
        exitKioskMode
      }}
    >
      {children}
    </KioskModeContext.Provider>
  )
}

KioskModeContextProvider.propTypes = {
  children: PropTypes.node
}
